
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","cx":"18","cy":"18","r":"18"}}),_c('circle',{attrs:{"fill":"#111","fill-rule":"nonzero","cx":"18","cy":"27.818","r":"1"}}),_c('circle',{attrs:{"stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","cx":"17.818","cy":"27.818","r":"1"}}),_c('path',{attrs:{"d":"M13 7.962c3.402-1.504 7.805-1.325 9.31 1.11 1.505 2.435.465 5.265-2.112 7.445-2.578 2.18-3.107 3.492-3.107 5.21","stroke":"#111","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    